import { render, staticRenderFns } from "./QPopover.vue?vue&type=template&id=f78abdd8&"
import script from "./QPopover.vue?vue&type=script&lang=js&"
export * from "./QPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports